import React from 'react';
import ShipmentLabelChip from './ShipmentLabelChip';
import type { ShipmentLabelView } from '../../api/generated/models/ShipmentLabelView';

interface ShipmentLabelListProps {
  labels: ShipmentLabelView[];
  max?: number;
}

const ShipmentLabelList: React.FC<ShipmentLabelListProps> = ({
  labels,
  max = 2,
}) => {
  if (!labels.length) return null;
  const visible = labels.slice(0, max);
  const extra = labels.length - visible.length;

  return (
    <span className="shipment-label-list">
      {visible.map((l) => (
        <ShipmentLabelChip key={l.id} label={l} />
      ))}
      {extra > 0 && (
        <span className="shipment-label-chip shipment-label-chip--more">
          +{extra}
        </span>
      )}
    </span>
  );
};

export default ShipmentLabelList;
